// named export (recommended)
export const PRIVATE_JET = {
    // section: ["overviewSection", "commercialOperationalBenefits", "communicationChannel"],
    href: "/investments/private-jet",
    overviewSection: {
        sectionId: "rentalInvestment",
        title: "Overview",
        subtitle: "Welcome to RSL Private Jet, invest in world-class aircraft for luxury, income, and freedom.",
        cards: [
            {
                title: "Consultation & Commitment",
                body: "Covers the full process from initial inquiry to investor commitment, supported by clear documentation.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "Welcome Pack Delivery",
                body: "Shareholding confirmation, Term sheet & investment summary, ROI schedule, support contact",
                arrow: "/img/app/Right-bottom-arrow.svg",
            },
            {
                title: "Ongoing Investment Management",
                body: "Get regular performance updates, transparent reports via investor portal, dedicated support for all needs.",
                arrow: "/img/app/Right-top-arrow.svg",
            },
            {
                title: "ROI Distribution & Reporting",
                body: "Returns follow the agreed schedule with regular reports and ongoing reinvestment guidance.",
            },
        ],
        button: { text: "Invest Now", link: "#" },
    },
    commercialOperationalBenefits: {
        subtitle: "Choose which suits you better",
        title: "Our Investment Models",
        accentColor: "#0F7F8A",
        sellers: {
            title: "Fractional Ownership",
            icons: "/img/investments/commercial/oval1.svg",
            items: [
                "Start with just AED 220,000",
                "15–20% returns annually, paid semi-annually",
                "Fixed 4-year term with resale or re-lease exit options",
                "Zero operational burden, fully managed",
            ]
        },
        buyers: {
            title: "Full Ownership",
            icons: "/img/investments/commercial/oval2.svg",
            items: [
                "Register the jet in your name or company",
                "RSL handles crew, maintenance & charter sales",
                "Revenue potential exceeds USD 1 million/year from charter use",
                "Ultimate control, prestige, and long-term asset value",
            ]
        },
        strategic: {
            title: "Co-Ownership",
            icons: "/img/investments/commercial/oval3.svg",
            items: [
                "Share ownership (often 50%) with RSL",
                "Assured flight hours and priority usage",
                "Charter revenue offsets maintenance & operating costs",
                "Lower upfront investment with strong returns",
            ]
        }, leaseToOwn: {
            title: "Lease-to-Own",
            icons: "/img/investments/commercial/oval3.svg",
            items: [
                "Own your jet in 3–5 years via structured payments",
                "Charter earnings contribute to payments",
                "Title transfers to you at end of term",
                "Perfect if you want ownership without full capital outlay upfront",
            ],
        },
        images: {
            rightTop: { src: "/img/investments/commercial/full-ownership.svg", alt: "Full Ownership" },
            leftMiddle: { src: "/img/investments/commercial/fractional-ownership.svg", alt: "Fractional Ownership" },
            rightBottom: { src: "/img/investments/commercial/co-ownership.svg", alt: "Co Ownership" },
            lastBottom: { src: "/img/investments/commercial/lease-to-own.svg", alt: "Lease to Own" },
        },
        button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        title: "Communication Channel",
        subtitle:
            "Choose which suits you better",
        bottomHeader: "RSL ensures smooth communication and transparency for all investors and drivers:",
        cardData: [
            {
                heading: "Call Center (UAE):",
                iconSrc: "/img/investments/phone.svg",
                iconAlt: "Phone",
                url: [
                    {
                        href: "tel:+97143977746",
                        label: "+971 4 397 7746"
                    }
                ]
            },
            {
                heading: "Email (Investors):",
                iconSrc: "/img/investments/email.svg",
                iconAlt: "Email",
                url: [
                    {
                        href: "mailto:investors@royalsmartlifestyle.com",
                        label: "investors@royalsmartlifestyle.com"
                    }
                ]
            },
            {
                heading: "Websites",
                iconSrc: "/img/investments/globe.svg",
                iconAlt: "Globe",
                url: [{
                    href: "https://www.royalsmartlimousine.com",
                    label: "https://www.royalsmartlimousine.com"
                }]
            }
        ],
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const PRIVATE_JET_PAGE = {
    carToInvest: {
        sectionId: "carToInvest",
        title: "Pick Your Jet To Invest",
        subtitle:
            "Make journey comfortable with",
        filters: ["All", "Sedan", "SUVs"],
        type: "jet",
        options: [
            { value: "full", label: "Full Ownership" },
            { value: "fractional", label: "Fractional Ownership" },
            { value: "jet-card", label: "Jet Card" },
            { value: "charter", label: "On-Demand Charter" },
        ],
        carData: [
            {
                id: 1,
                segment: "jet",
                title: "Gulfstream 200",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "100" },
                    { label: "Available Shares", value: "0" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "10,667",
                    period: "/Per Month"
                }, {
                    price: "6,50,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            }, {
                id: 2,
                segment: "jet",
                title: "Bombardier 650",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "75" },
                    { label: "Available Shares", value: "25" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 3,
                segment: "jet",
                title: "Bombardier 650",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "75" },
                    { label: "Available Shares", value: "25" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 4,
                segment: "jet",
                title: "Bombardier 650",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "75" },
                    { label: "Available Shares", value: "25" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 5,
                segment: "jet",
                title: "Bombardier 650",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "75" },
                    { label: "Available Shares", value: "25" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
            {
                id: 6,
                segment: "jet",
                title: "Bombardier 650",
                roiPercentage: "Apr.Annual ROI-110%",
                image: "/img/investments/privatejet/jet.svg",
                stats: [
                    { label: "Total Shares", value: "100" },
                    { label: "Sold Shares", value: "75" },
                    { label: "Available Shares", value: "25" },
                ],
                bottomLabel: "Profit after expenses",
                pricePeriod: [{
                    price: "7,000",
                    period: "/Per Month"
                }, {
                    price: "70,000",
                    period: "/After 5 Years"
                }],
                breakdown: [
                    { label: "Fuel", value: "700 AED" },
                    { label: "Salik", value: "500 AED" },
                    { label: "Maintainance", value: "300 AED" },
                ]
            },
        ],
        button: { text: "Investment Breakdown", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "Investment Guide",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/privatejet/investmentGuide.svg",
            alt: " Hands offering coins"
        },
        bgcolor: "#f8f8f8",
        width: "75%", button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "RSLSuperApp",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}